import { render } from "./PagePurchase.vue?vue&type=template&id=2a8636c8"
import script from "./PagePurchase.vue?vue&type=script&lang=js"
export * from "./PagePurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/containers/PagePurchase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a8636c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a8636c8', __exports__)) {
    api.reload('2a8636c8', __exports__)
  }
  
  module.hot.accept("./PagePurchase.vue?vue&type=template&id=2a8636c8", () => {
    api.rerender('2a8636c8', render)
  })

}


export default __exports__